import React from 'react';
import MenuDropdown from '@app/components/common/MenuDropdown/MenuDropdown';
import MenuIcon from '@app/components/icons/menu';
import { MenuItem } from '@mui/material';
import { useAppSelector } from '@app/store/hooks';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import { MemberDto } from '@app/store/project/types';
import { useModal } from '@app/components/modal-views/context';
import { selectAuth } from '@app/store/auth/authSlice';

interface IActionDropDown {
    memberInfo: MemberDto;
    className?: string;
    disabled?: boolean;
}

interface DropdownProps {
    id: string;
    text: string;
    handleButton: () => void;
    shouldRender: () => boolean;
    class: string;
}

function MemberActionDropdown({ className, disabled = false, memberInfo }: IActionDropDown) {
    const { t } = useTranslation(['common', 'document', 'organization']);
    const { openModal } = useModal();
    const auth = useAppSelector(selectAuth);
    const isSameUser = auth.email === memberInfo.userInfo.email;

    const handleRenameUserName = async () => {
        openModal('CHANGE_USERNAME_MODAL', { name: memberInfo.userInfo.name, email: memberInfo.userInfo.email, userId: memberInfo.userInfo.userId });
    };

    const DropdownItemsArray: Array<DropdownProps> = [
        {
            id: 'update-user-name',
            text: t('updateDisplayUserName', { ns: 'common' }),
            handleButton: handleRenameUserName,
            shouldRender: () => !isSameUser,
            class: 'text-gray-900'
        }
    ];

    return (
        <>
            <MenuDropdown
                showExpandMore={false}
                width={220}
                disabled={disabled}
                className={className}
                onClick={(event: any) => {
                    event.stopPropagation();
                    event.preventDefault();
                }}
                PaperProps={{
                    elevation: 0,

                    sx: {
                        width: 220,
                        overflow: 'hidden',
                        borderRadius: 2,
                        filter: 'drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.15))',
                        mt: 0.5,
                        padding: 0
                    }
                }}
                id={`action-menu-${memberInfo.userInfo.email}`}
                menuTitle={t('action', { ns: 'organization' })}
                menuContent={<MenuIcon className={cn(disabled && 'cursor-not-allowed opacity-50')} />}
            >
                <p className="p3 px-4 py-2 text-gray-500">{t('action', { ns: 'organization' })}</p>

                {DropdownItemsArray.filter((item) => item != null).map((dropdownItem: DropdownProps) => {
                    if (dropdownItem.shouldRender()) {
                        return (
                            <MenuItem data-testid={dropdownItem.id} key={dropdownItem.text} className="p2 flex gap-2 py-2 text-black-1" onClick={dropdownItem.handleButton}>
                                <p className={dropdownItem.class}>{dropdownItem.text}</p>
                            </MenuItem>
                        );
                    }
                })}
            </MenuDropdown>
        </>
    );
}
export default MemberActionDropdown;
